import { render, staticRenderFns } from "./BillingPaymentMethodForm.vue?vue&type=template&id=455b4839&scoped=true&"
import script from "./BillingPaymentMethodForm.vue?vue&type=script&lang=js&"
export * from "./BillingPaymentMethodForm.vue?vue&type=script&lang=js&"
import style0 from "./BillingPaymentMethodForm.vue?vue&type=style&index=0&id=455b4839&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455b4839",
  null
  
)

export default component.exports